// FILE: src/components/ui/button.jsx
// ==================================
import React from "react";
import { getPlatformButtonStyles } from "../../components/utils/PlatformButtonStyles";

// простенький cn без twMerge (нам достаточно склейки)
const cn = (...parts) => parts.filter(Boolean).join(" ");

const base =
  "inline-flex items-center justify-center gap-2 rounded-lg font-semibold transition " +
  "focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-500/70 " +
  "ring-1 ring-white/15 backdrop-blur-sm shadow";

const sizes = {
  xs: "h-8 px-3 text-xs",
  sm: "h-9 px-3 text-sm",
  default: "h-10 px-4 text-sm",
  lg: "h-11 px-5 text-base",
  icon: "h-9 w-9 p-0",
};

// фирменный градиент сайта (как на кнопке «Войти»)
const sitePrimary =
  "bg-gradient-to-r from-violet-600 via-fuchsia-600 to-pink-600 text-white " +
  "hover:from-violet-500 hover:via-fuchsia-500 hover:to-pink-500";

// дополнительные варианты в твоём стиле
const variants = {
  // ставим 'primary' = стиль сайта и делаем его дефолтом
  primary: sitePrimary,
  default: sitePrimary,

  subtle: "bg-white/10 text-white hover:bg-white/15",
  outline:
    "bg-transparent border border-white/15 text-white hover:bg-white/10",
  destructive: "bg-rose-600 text-white hover:bg-rose-700",
  ghost: "bg-transparent text-white hover:bg-white/10",
};

/**
 * Доп. вариант для платформ — тянет цвета из getPlatformButtonStyles()
 * Используй variant="platform" и передай prop platform={'kick'|'twitch'|'wtv'|'w.tv'}
 */
const platformVariant = (platform) => {
  const pid = String(platform || "").trim().toLowerCase().replace(/[^a-z]/g, "");
  const { primaryColor, hoverColor, glowColor, TwotextColor } =
    getPlatformButtonStyles(pid);
  // делаем цвет читаемым и стойким к оверлеям
  return cn(primaryColor, hoverColor, glowColor, TwotextColor, "!bg-opacity-100", "!text-white");
};

export const Button = React.forwardRef(
  (
    {
      variant = "default",
      size = "default",
      platform,        // опц., нужно только для variant="platform"
      className = "",
      disabled = false,
      type = "button",
      ...props
    },
    ref
  ) => {
    const sizeCls = sizes[size] || sizes.default;

    const variantCls =
      variant === "platform"
        ? platformVariant(platform)
        : variants[variant] || variants.default;

    // важное: disabled не превращает кнопку в серую «тряпку»
    const disabledCls = "disabled:opacity-70 disabled:pointer-events-none disabled:!text-white disabled:!bg-opacity-100";

    return (
      <button
        ref={ref}
        type={type}
        disabled={disabled}
        className={cn(base, sizeCls, variantCls, disabledCls, className)}
        data-variant={variant}
        {...props}
      />
    );
  }
);
Button.displayName = "Button";
